import React from 'react';
import Layout from '@app/layouts/_layout';
import { getHowWeWorkContent, getLayoutProps, getOurValuesContent, getTrustedByContent, getWhoWeAreContent } from '@app/utils/serverSidePropsUtils';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { IWhoWeAreProps } from '@app/models/props/who-we-are';
import WhoWeAreUi from '@app/components/ui/who-we-are';
import HowWeWorkUi from '@app/components/ui/how-we-work';
import OurValues from '@app/components/ui/our-values';
import TrustedBy from '@app/components/ui/trusted-by';
import RadialGradient from '@app/components/ui/radial-gradient';

export async function getServerSideProps({ locale }: any) {
    const [whoWeAre, howWeWork, trustedBy, ourValues] = await Promise.all([getWhoWeAreContent(), getHowWeWorkContent(), getTrustedByContent(), getOurValuesContent()]);
    const layoutProps = await getLayoutProps();
    if (!whoWeAre) {
        return {
            notFound: true
        };
    }
    return {
        props: {
            whoWeAre,
            howWeWork,
            trustedBy,
            ourValues,
            ...layoutProps,
            ...(await serverSideTranslations(locale, ['common'], null, ['en', 'nl']))
        }
    };
}

function WhoWeAre(props: IWhoWeAreProps) {
    const { whoWeAre, products, socialMedias, howWeWork, trustedBy, ourValues, settings, locations } = props;
    return (
        <Layout locations={locations} socialMedias={socialMedias} settings={settings} products={products}>
            <RadialGradient />
            <div>
                {whoWeAre && <WhoWeAreUi whoWeAre={whoWeAre} />}
                {howWeWork && <HowWeWorkUi howWeWork={howWeWork} />}
                {trustedBy && <TrustedBy trustedBy={trustedBy} />}
                {ourValues && ourValues.values && <OurValues ourValues={ourValues.values} />}
            </div>
        </Layout>
    );
}

export default WhoWeAre;
